import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCategory(cat?: string): string {
  if (!cat) return '';
  const mapping: Record<string, string> = {
    CARS: 'Cars',
    BIKES: 'Bikes',
    MOBILES: 'Mobiles',
    REAL_ESTATE: 'Real Estate',
    RENT_ROOMMATES: 'House Rents / Room Mates',
    BUS_TRUCKS_AUTOS_VEHICLES: 'Bus / Trucks / Autos / Other Vehicles',
    AUTOMOBILE_ACCESSORIES: 'Automobile Accessories',
    PETS_AND_HOBBIES: 'Pets & Hobbies',
    COMMUNITY_AND_EVENTS: 'Community & Events',
    FURNITURE_INTERIORS: 'Furniture / Interiors',
    ELECTRONICS_AND_APPLIANCES: 'Electronics & Appliances',
    PERSONAL_AND_COMMUNITY: 'Personal & Community',
    JOBS_AND_SERVICES: 'Jobs & Services',
    FASHION_AND_LIFESTYLE: 'Fashion & Lifestyle',
    SAFETY_PROTECTION: 'Safety / Protection',
    BUSINESS_FINANCIAL: 'Business / Financial',
    PROFESSIONAL_SERVICES: 'Professional Services / Trades',
    INSURANCE_LEGAL: 'Insurance / Legal',
    MAINTENANCE_AND_REPAIR: 'Maintenance & Repair',
    PERSONAL_SERVICES: 'Personal Services',
    SALES_AUCTIONS: 'Sales / Auctions / Discounts',
    GIFTS_SPECIAL_OCCASIONS: 'Gifts / Special Occasions',
    TRAVEL_ENTERTAINMENT: 'Travel / Entertainment',
    WATER_FILTRATION: 'Water Filtration / Purification',
    SECURITY_GUARDS: 'Security Guards',
    OTHER_SERVICES: 'Other Services',
  };
  return mapping[cat.toUpperCase()] || cat;
}

export function getAvatarUrl(avatar?: string | null): string | null {
  if (!avatar || !avatar.trim()) return null;
  const trimmed = avatar.trim();
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }
  if (trimmed.startsWith('/api/')) {
    return trimmed;
  }
  return `/api/users/avatar/${trimmed}`;
}
